import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { subscribe_welcome_path } from '../routes.js';
import {
  CreateTeamSubscriptionParams,
  createTeamSubscription,
} from '../utils/backend-api/groupSubscription';

export default function useCreateTeamSubscription() {
  const { mutateAsync, mutate, isLoading } = useMutation(
    (params: CreateTeamSubscriptionParams) => createTeamSubscription(params),
    {
      onSuccess: () => {
        window.location = subscribe_welcome_path();
      },
      onError: (errors: string[]) => {
        toast.error(errors.join(';'));
      },
    }
  );
  return { mutateAsync, mutate, isLoading };
}
